declare var Slider: any;

export default class SiteProduct {
    private static initGallery() {
        const $uid = $('.productgallery');
        const $preview = $('.productgallery__preview', $uid);
        const $previewimage = $('.productgallery__preview-image', $preview);
        const $thumbslist = $('.productgallery__thumbs', $uid);
        const $thumbs = $('.productgallery__thumb', $uid);

        let fancyindex = 0;

        if ($thumbs.length) {
            let sel = null;
            let bypass = false;
            let big = null;

            const showAnim = (show: boolean, force: boolean, done?: () => void) => {
                if (force) {
                    if (show) {
                        $previewimage.show();
                    } else {
                        $previewimage.hide();
                    }

                    if (done) {
                        done();
                    }
                } else {
                    if (show) {
                        $previewimage.fadeIn(200, () => {
                            if (done) {
                                done();
                            }
                        });
                    } else {
                        $previewimage.fadeOut(200, () => {
                            if (done) {
                                done();
                            }
                        });
                    }
                }
            };

            const show = (ix: number, force?: boolean) => {
                if (ix == sel || bypass) {
                    return;
                }
                fancyindex = ix;

                if (ix >= $thumbs.length) {
                    ix = $thumbs.length -1;
                }

                if (ix < 0) {
                    ix = 0;
                }

                const $thumb = $thumbs.eq(ix);

                $thumbs.not($thumb).removeClass('productgallery__thumb--selected');
                $thumb.addClass('productgallery__thumb--selected');

                const url = $thumb.data('image');
                big = $thumb.data('big');
                sel = ix;

                bypass = true;

                showAnim(false, force, () => {
                    const $img = $('<img>');

                    $img.promise('load').done(() => {
                        showAnim(true, force, () => {
                            bypass = false;
                        });
                    });

                    $img.prop('src', url);
                    $previewimage.empty().append($img);
                });

            };

            if ($thumbs.length > 1) {
                $thumbs.each((ix, el) => {
                    const $thumb = $(el);

                    $thumb.on('click', (e) => {
                        show(ix);
                    });
                });
            } else {
                $thumbslist.hide();
            }

            const $fboximages = [];
            $thumbs.each((ix, el) =>{
                $fboximages.push({
                    src: $(el).data('big'),
                });
            });

            $preview.on('click', (e) => {
                (<any> $).fancybox.open($fboximages, {
                    loop: true
                }, fancyindex);
            });

            show(0, true);
        } else {
            $uid.addClass('productgallery--no-images');
        }

        $uid.addClass('productgallery--inited');
    }

    public static discover($parent?: JQuery): void {
        let $addtocart = $('.productheader .addtocart', $parent);
        let $quantity = $('.addtocart__quantity input', $addtocart);
        let $total = $('.addtocart__total-value', $addtocart);
        let $totalval = $('span b', $total);

        let price = parseFloat($total.data('price'));

        function update() {
            let quantity = $quantity.val();

            $totalval.text(quantity * price);
        }

        (<any> $quantity).qSpinner({
            value: $quantity.val(),

            onLazySpin: function(e, val) {
                update();
            }
        });
    }

    public static initHtml(): void {
        this.initGallery();

        this.discover();
    }

    public static initModule(): void {
        (<any> window).SiteProduct = SiteProduct;
    }
}
